<template>
  <div>
    <b-breadcrumb :items="items" style="background-color: transparent"></b-breadcrumb>
    <b-container>
        <b-row align-h="center">
            <b-col sm="12">
                <h1 class="text-center">
                    Fale conosco
                </h1>
            </b-col>
            <b-col sm="12" md="6">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group
                        id="input-group-1"
                        label="Email address:"
                        label-for="input-1"
                        description="We'll never share your email with anyone else."
                    >
                        <b-form-input
                        id="input-1"
                        v-model="form.email"
                        type="email"
                        required
                        placeholder="Enter email"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Your Name:" label-for="input-2">
                        <b-form-input
                        id="input-2"
                        v-model="form.name"
                        required
                        placeholder="Enter name"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="textarea" label="Mensagem" label-for="textarea">
                        <b-form-textarea
                            id="textarea"
                            v-model="form.text"
                            placeholder="Enter something..."
                            rows="3"
                            max-rows="6"
                            ></b-form-textarea>
                    </b-form-group>
                    

                    <b-button type="submit" variant="primary" class="btn btn-block">Enviar</b-button>
                    </b-form>
            </b-col>
        </b-row>
    </b-container>

  </div>
</template>

<script>
  export default {
      name: 'Contact',
    data() {
      return {
        form: {
          email: '',
          name: '',
          text: ""
        },
        show: true,
        items: [
          {
            text: 'Home',
            to: { name: 'categories' }
          },
          {
            text: 'Contato',
            to: { name: 'contact' }
          }
        ],
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        alert(JSON.stringify(this.form))
      },
    }
  }
</script>
<style scoped>
a {
  color: #2c3e50;
}
</style>